import React, { createContext, useState, ReactNode } from 'react';

type ConfigType = { categorie: any[], formazione: any[], specializzando: any[] , professioni: any[], 
  universita:any[], facolta: any[],
  adminUser:string };
const configDefault: ConfigType = { categorie: [], formazione: [] , specializzando: [] , professioni: [] ,  universita: [], facolta:  [], adminUser:""};

const ConfigContext = createContext<{
  config: ConfigType,
  setConfig: React.Dispatch<React.SetStateAction<ConfigType>>
}>({
  config: configDefault,
  setConfig: () => {}
});

const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfig] = useState<ConfigType>(configDefault);
 
  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export { ConfigContext, ConfigProvider, configDefault };